import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import hideConsentNotice from '~/middleware/hideConsentNotice'
import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'
import redirectIfWebview from '~/scopes/webviews/middleware/redirectIfWebview'

import { routeHasValidParams } from '../cms/navigation/routeHasValidParams'
import { CMS } from '../cms/routes-names'

import { LEGAL } from './route-names'

export default (): RouteRecordRaw[] => {
  const { FF_REPORT_ILLICIT_CONTENT } = useRuntimeConfig().public

  const legalRoutes: RouteRecordRaw[] = [
    {
      path: 'get-my-visitor-id',
      name: LEGAL.GET_VISITOR_ID,
      component: () => import('~/scopes/legal/pages/VisitorId.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
        tracking: { contentGroup: 'Internal' },
      },
    },
    {
      path: 'report-illicit-content',
      name: LEGAL.REPORT_ILLICIT_CONTENT,
      component: () => import('~/scopes/legal/pages/ReportIllicitContent.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
        routeExists: () => FF_REPORT_ILLICIT_CONTENT === true,
        tracking: { contentGroup: 'Internal' },
      },
    },
  ]

  const legalCmsRoutes: RouteRecordRaw[] = [
    {
      path: 'legal/previous/:pageName',
      component: () => import('~/scopes/cms/Landing.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
        middleware: [hideConsentNotice, redirectIfWebview],
        routeExists: routeHasValidParams,
        tracking: { contentGroup: 'Corporate' },
      },
      children: [
        {
          name: CMS.LEGAL_PREVIOUS_VERSION,
          path: '',
          component: () =>
            import('~/scopes/legal/pages/LegalTemplate/LegalTemplate.vue'),
          meta: {
            middleware: [hideConsentNotice, redirectIfWebview],
            noCookieModal: true,
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
    {
      path: 'legal/:pageName',
      component: () => import('~/scopes/cms/Landing.vue'),
      meta: {
        tracking: { contentGroup: 'Corporate' },
      },
      children: [
        {
          name: CMS.LEGAL_PAGE,
          path: '',
          component: () =>
            import('~/scopes/legal/pages/LegalTemplate/LegalTemplate.vue'),
          meta: {
            middleware: [hideConsentNotice, redirectIfWebview],
            routeExists: routeHasValidParams,
            noCookieModal: true,
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
  ]

  const webviewRoutes = generateWebviewRoutes(legalCmsRoutes)

  return [...legalRoutes, ...legalCmsRoutes, ...webviewRoutes]
}
